import {
  CHANGE_PAYOFF_STEP,
  CLEAR_STATEMENT,
  CREATE_PAYOFF_STATEMENT,
  CREATE_PAYOFF_STATEMENT_FAILURE,
  CREATE_PAYOFF_STATEMENT_SUCCESS,
  FETCH_PAYOFF_DATES,
  FETCH_PAYOFF_DATES_FAILURE,
  FETCH_PAYOFF_DATES_SUCCESS,
  FETCH_PAYOFF_DOCUMENT,
  FETCH_PAYOFF_DOCUMENT_FAILURE,
  FETCH_PAYOFF_DOCUMENT_SUCCESS,
  FETCH_PAYOFF_HISTORY,
  FETCH_PAYOFF_HISTORY_FAILURE,
  FETCH_PAYOFF_HISTORY_SUCCESS,
  FETCH_PAYOFF_STATEMENT,
  FETCH_PAYOFF_STATEMENT_FAILURE,
  FETCH_PAYOFF_STATEMENT_SUCCESS,
  RESET_BANNER_ERROR,
  RESET_STATE,
  SET_FILE,
  TOGGLE_DRAWER,
  UPDATE_REQUEST_TYPE,
  UPDATE_SELECTED_DATE,
  UPDATE_SELECTED_PAYOFF_REASON,
} from './constants';

export function changePayoffStep(payoffStep) {
  return {
    payload: { payoffStep },
    type: CHANGE_PAYOFF_STEP,
  };
}

export function clearStatement() {
  return { type: CLEAR_STATEMENT };
}

export function createPayoffStatement({
  loanNumber,
  payoffDate,
  payoffReason,
  requestType,
}) {
  return {
    payload: {
      loanNumber,
      payoffDate,
      payoffReason,
      requestType,
    },
    type: CREATE_PAYOFF_STATEMENT,
  };
}

export function createPayoffStatementFailure() {
  return { type: CREATE_PAYOFF_STATEMENT_FAILURE };
}

export function createPayoffStatementSuccess() {
  return { type: CREATE_PAYOFF_STATEMENT_SUCCESS };
}

export function fetchPayoffDates(loanNumber) {
  return {
    payload: { loanNumber },
    type: FETCH_PAYOFF_DATES,
  };
}

export function fetchPayoffDatesFailure(partialError) {
  return {
    payload: { partialError },
    type: FETCH_PAYOFF_DATES_FAILURE,
  };
}

export function fetchPayoffDatesSuccess({
  availablePayDownDates,
  availablePayOffDates,
  availablePayOffReasons,
}) {
  return {
    payload: { availablePayDownDates, availablePayOffDates, availablePayOffReasons },
    type: FETCH_PAYOFF_DATES_SUCCESS,
  };
}

export function fetchPayoffDocument({
  dispatchSetFile,
  dispatchToggleDrawer,
  loanNumber,
  token,
}) {
  return {
    payload: {
      dispatchSetFile,
      dispatchToggleDrawer,
      loanNumber,
      token,
    },
    type: FETCH_PAYOFF_DOCUMENT,
  };
}

export function fetchPayoffDocumentFailure(error) {
  return {
    payload: { error },
    type: FETCH_PAYOFF_DOCUMENT_FAILURE,
  };
}

export function fetchPayoffDocumentSuccess() {
  return { type: FETCH_PAYOFF_DOCUMENT_SUCCESS };
}

export function fetchPayoffStatement() {
  return { type: FETCH_PAYOFF_STATEMENT };
}

export function fetchPayoffStatementFailure(error) {
  return {
    payload: { error },
    type: FETCH_PAYOFF_STATEMENT_FAILURE,
  };
}

export function fetchPayoffStatementSuccess({
  document,
  mobileDocument,
  status,
}) {
  return {
    payload: {
      document,
      mobileDocument,
      status,
    },
    type: FETCH_PAYOFF_STATEMENT_SUCCESS,
  };
}

export function fetchPayoffHistory(loanNumber) {
  return {
    payload: { loanNumber },
    type: FETCH_PAYOFF_HISTORY,
  };
}

export function fetchPayoffHistoryFailure() {
  return { type: FETCH_PAYOFF_HISTORY_FAILURE };
}

export function fetchPayoffHistorySuccess(items) {
  return {
    payload: { items },
    type: FETCH_PAYOFF_HISTORY_SUCCESS,
  };
}

export function resetBannerError() {
  return { type: RESET_BANNER_ERROR };
}

export function resetState() {
  return { type: RESET_STATE };
}

export function setFile(payload) {
  return {
    payload,
    type: SET_FILE,
  };
}

export function toggleDrawer(drawerState) {
  return {
    payload: { drawerState },
    type: TOGGLE_DRAWER,
  };
}

export function updateRequestType(requestType) {
  return {
    payload: { requestType },
    type: UPDATE_REQUEST_TYPE,
  };
}

export function updateSelectedDate(date) {
  return {
    payload: { date },
    type: UPDATE_SELECTED_DATE,
  };
}

export function updateSelectedPayOffReason(reason) {
  return {
    payload: { reason },
    type: UPDATE_SELECTED_PAYOFF_REASON,
  };
}
